import { AppointmentDataGetter, AppointmentDisplayData } from './AppointmentDataGetter'
import { PresenceStatus } from '../constants'
import { formatMessage } from '../../../constants/strings/intl/intlHooks'
import { messages } from '../../../constants/strings/messages'
import { formatDateWithMonthName } from '../../../utils/formatters'
import { GetUserKeysDeliveryEventInvitations_listUserKeysDeliveryEventInvitations } from '../../../services/types/GetUserKeysDeliveryEventInvitations'
import dayjs from 'dayjs'

interface KeysDeliveryCallbackFunctions {
  onPressCancelKeysDelivery: (invitationId: string, eventId: string, constructionName: string) => void
  onPressConfirmKeysDelivery: (invitationId: string, eventId: string) => void
}

export class KeysDeliveryAppointmentDataGetter extends AppointmentDataGetter {
  functions: KeysDeliveryCallbackFunctions

  constructor(functions: KeysDeliveryCallbackFunctions) {
    super()
    this.functions = functions
  }

  public getAppointmentDisplayData(
    appointment: GetUserKeysDeliveryEventInvitations_listUserKeysDeliveryEventInvitations
  ): AppointmentDisplayData {
    return {
      bottomMessage: formatMessage(messages.appointments_keysDeliveryContactUs),
      cancelAction: () =>
        this.functions.onPressCancelKeysDelivery(
          appointment?.id,
          appointment?.keysDeliveryEvent?.id,
          appointment?.keysDeliveryEvent?.construction?.name
        ),
      confirmAction: () =>
        this.functions.onPressConfirmKeysDelivery(appointment?.id, appointment?.keysDeliveryEvent?.id),
      constructionName: appointment?.keysDeliveryEvent?.construction?.name,
      eventDate: formatDateWithMonthName(appointment?.keysDeliveryEvent?.date),
      eventTime: dayjs(appointment?.keysDeliveryEvent?.date)
        .hour()
        .toString(),
      eventAddress: appointment?.keysDeliveryEvent?.construction?.address,
      presenceStatus: appointment?.isAttending ? PresenceStatus.CONFIRMED : PresenceStatus.CANCELLED,
      title: formatMessage(messages.appointments_keysDeliveryTitleLabel),
    }
  }
}
